import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NotDNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    if (!value) {
      return null; // Ingen verdi, la andre valideringer (f.eks. required) ta seg av dette
    }

    const numberPattern = /^\d{11}$/;

    const day = parseInt(value.substring(0, 2), 10);
    const month = parseInt(value.substring(2, 4), 10);

    // Sjekk om det er et D-nummer ved å sjekke om dagen er i rekkevidden 41-71 (dag + 40)
    if (numberPattern.test(value) && day >= 41 && day <= 71 && month >= 1 && month <= 12) {
      return { isDNumber: { value: control.value } };
    }

    return null;
  };
}
